<template>
  <div class="flex flex-wrap">
    <div class="w-full">
      <ul class="flex mb-0 list-none flex-wrap pt-3 pb-4 flex-row">
        <li class="-mb-px mr-2 last:mr-0 flex-auto text-center">
          <a
            class="text-xs font-bold uppercase px-5 py-3 shadow-lg rounded block leading-normal"
            @click="toggleTabs(1)"
            :class="getTabHeaderClass(1)">
            Data Diri &amp; Sekolah Asal
          </a>
        </li>
        <li class="-mb-px mr-2 last:mr-0 flex-auto text-center">
          <a
            class="text-xs font-bold uppercase px-5 py-3 shadow-lg rounded block leading-normal"
            @click="toggleTabs(2)"
            :class="getTabHeaderClass(2)">
            Data Orang Tua
          </a>
        </li>
        <li class="-mb-px mr-2 last:mr-0 flex-auto text-center">
          <a
            class="text-xs font-bold uppercase px-5 py-3 shadow-lg rounded block leading-normal"
            @click="toggleTabs(3)"
            :class="getTabHeaderClass(3)">
            Data Kampus
          </a>
        </li>
        <li class="-mb-px mr-2 last:mr-0 flex-auto text-center">
          <a
            class="text-xs font-bold uppercase px-5 py-3 shadow-lg rounded block leading-normal"
            @click="toggleTabs(4)"
            :class="getTabHeaderClass(4)">
            Unggah Berkas
          </a>
        </li>
      </ul>
      <div
        class="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded">
        <div class="px-4 py-5 flex-auto">
          <div class="tab-content tab-space">
            <div :class="getTabContentClass(1)">
              <slot name="tab1" />
            </div>
            <div :class="getTabContentClass(2)">
              <slot name="tab2" />
            </div>
            <div :class="getTabContentClass(3)">
              <slot name="tab3" />
            </div>
            <div :class="getTabContentClass(4)">
              <slot name="tab4" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    step: {
      type: Number,
      default: 1,
    },
    openTab: {
      type: Number,
      default: 1,
    },
  },
  methods: {
    toggleTabs (tabNumber) {
      this.$emit('tab-changed', tabNumber)
    },
    getTabHeaderClass (idx) {
      return idx > this.step && idx !== 4
        ? 'text-gray-400 bg-gray-300'
        : this.openTab === idx
        ? 'text-white bg-indigo-600'
        : 'text-indigo-600 bg-white'
    },
    getTabContentClass (idx) {
      return this.openTab === idx ? 'block' : 'hidden'
    },
  },
}
</script>
